import React from "react";
import { Link } from "@reach/router";
import MaterialTable, { Column } from "@material-table/core";
import { Grid } from "@material-ui/core";

type MessageRow = {
  createdAt: string;
  interestUrl: string;
  type: string;
  recipientName: string;
  subject: string;
  statusMessage: string;
  body: string;
}
interface MessagesTableProps {
  rowData: MessageRow[];
}
const NoWrap: React.FC<{value: string}> = ({ value }) => (
  <span style={{ whiteSpace: "nowrap" }}>{value}</span>);
const columns: Array<Column<MessageRow>> = [
  { title: "Name", field: "recipientName", render: ({ interestUrl, recipientName }) => <Link to={interestUrl}>{recipientName}</Link>, width: 220 },
  { title: "Type", field: "type", width: 100 },
  { title: "Status Code", field: "statusMessage", width: 120 },
  { title: "Date Sent", field: "createdAt", render: ({ createdAt }) => <NoWrap value={createdAt} />, width: 130 },
  { title: "Subject", field: "subject", width: 200 },
  { title: "Message Preview", field: "body", render: ({ body }) => <NoWrap value={body} /> },
];
class MessagesTable extends React.Component<MessagesTableProps> {
  render (props = this.props): JSX.Element {
    return (
      <MaterialTable
        components={{ Container: Grid }}
        data={props.rowData}
        columns={columns}
        options={{ tableLayout: "fixed",
          pageSize: 25,
          showTitle: false,
          padding: "dense",
          search: false,
          toolbar: false }}
      />
    );
  }
}

export default MessagesTable;
